import axios from 'axios';
import VueAxios from 'vue-axios';

const api = axios.create({
  baseURL: '/api/v1',
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': window.Laravel?.csrfToken || '',
    'XSRF-TOKEN': window.Laravel?.csrfToken || '',
  },
});

// Add a response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error)) {
      console.error('Something went wrong when performing an API request:', error.message);
      console.error('Error details:', error.response?.data);
    }
    return Promise.reject(error);
  }
);

// Exporting as a plugin, so it can be installed on the app instance
export default {
  install(app) {
    app.use(VueAxios, api);
  },
};

// Also exporting the api instance to use it directly (if needed) elsewhere
export { api };
